<template>
  <div>
    <b-breadcrumb class="breadcrumb-slash mb-1">
      <b-breadcrumb-item :to="{ name: 'dashboard-1' }">
        {{ $t("HomePage.HomePage") }}
        <!-- Dashboard -->
      </b-breadcrumb-item>
      <b-breadcrumb-item active>
        {{ $t("ShopInformation.ShopInformation") }}
        <!-- ข้อมูลร้านค้า -->
      </b-breadcrumb-item>
    </b-breadcrumb>
    <b-card :title="$t('ShopInformation.GeneralInformation')">
      <b-row>
        <b-col
          cols="12"
          md="4"
        >
          <!-- Media -->
          <b-media class="mb-2">
            <template #aside>
              <b-avatar
                ref="previewEl"
                :src="shopModel.thumbnailUrl"
                size="90px"
                rounded
              />
            </template>

            <div class="d-flex flex-wrap" />
            <h4 class="mt-50">
              {{ shopName }}
            </h4>
            <!-- <p style="font-size: 12px">Active เมื่อ 10 นาที ที่ผ่านมา</p> -->
          </b-media>
          <b-list-group>
            <b-list-group-item
              class="d-flex"
              style="justify-content: space-between"
              :to="{ name: 'product-list' }"
            >
              <div>
                <feather-icon
                  icon="ArchiveIcon"
                  class="d-inline mr-1"
                />
                {{ $t("ShopInformation.ProductList") }}
                <!-- รายการสินค้า -->
              </div>

              <feather-icon
                icon="ChevronRightIcon"
                class="d-inline"
                style="margin-top: 0.3rem"
              />
            </b-list-group-item>
            <b-list-group-item
              class="d-flex"
              style="justify-content: space-between"
              :to="{ name: 'point-shop' }"
            >
              <div>
                <feather-icon
                  icon="LifeBuoyIcon"
                  class="d-inline mr-1"
                />
                {{ $t("ShopInformation.ShopRating") }}
                <!-- คะเนนร้านค้า -->
              </div>

              <feather-icon
                icon="ChevronRightIcon"
                class="d-inline"
                style="margin-top: 0.3rem"
              />
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col
          cols="12"
          md="8"
        >
          <validation-observer ref="simpleRules">
            <b-form>
              <h5 class="my-2">
                {{ $t("ShopInformation.AddCoverImages") }}
                <!-- เพิ่มรูปปก -->
              </h5>

              <div>
                <el-upload
                  ref="upload"
                  action="#"
                  list-type="picture-card"
                  :auto-upload="false"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :on-change="handleChange"
                  :file-list="fileListBanner"
                  accept="image/*"
                >
                  <i class="el-icon-plus" />
                </el-upload>

                <el-dialog :visible.sync="dialogVisible">
                  <img
                    width="100%"
                    :src="dialogImageUrl"
                    alt=""
                  >
                </el-dialog>
              </div>

              <p
                class="mt-1 mb-2"
                style="font-size: 12px"
              >
                {{ $t("ShopInformation.Size") }}
                <!-- * ขนาด : ไม่เกิน 5 Mb, 1280x1280px -->
                <br>
                <!-- 2. ระยะเวลา : 10-60 วินาที <br />
                3. นามสกุลไฟล์ : MP4 <br /> -->
                <!-- 2. หมายเหตุ :
                คุณสามารถเผยแพร่สินคำชิ้นนี้ได้ตั้งแต่ระหว่างที่วิดีโอกำลังอัปโหลด
                โดยวิดีโอจะแสดงให้เห็นหลังการอัปโหลดเสร็จสิ้น -->
              </p>

              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('ShopInformation.ShopName')"
                    label-for="name"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Name"
                      rules="required"
                    >
                      <b-form-input
                        id="name"
                        v-model="shopModel.shopName"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <b-form-group
                    :label="$t('ShopInformation.ShopDetails')"
                    label-for="description"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Description"
                      rules=""
                    >
                      <b-form-textarea
                        id="description"
                        v-model="shopModel.description"
                        rows="3"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- <b-row>
                <b-col>
                  <b-form-checkbox v-model="isShowProduct" value="A">
                    {{ $t("ShopInformation.ShowProductsOnTheSystem") }} -->
              <!-- เเสดงสินค้าบนระบบ -->
              <!-- </b-form-checkbox>
                </b-col>
              </b-row> -->

              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('ShopInformation.FullName')"
                    label-for="fullName"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="fullName"
                      rules="required"
                    >
                      <b-form-input
                        id="fullName"
                        v-model="shopModel.fullName"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('ShopInformation.contactCitizen')"
                    label-for="contactCitizen"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="contactCitizen"
                      rules="required"
                    >
                      <b-form-input
                        id="contactCitizen"
                        v-model="shopModel.contactCitizen"
                        :state="maxLength13"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('ShopInformation.ShopPhone')"
                    label-for="shopPhone"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Shop Phone"
                      rules="required"
                    >
                      <b-form-input
                        id="shopPhone"
                        v-model="shopModel.phone"
                        disabled
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('ShopInformation.ShopEmail')"
                    label-for="shopEmail"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Shop Email"
                      rules="required"
                    >
                      <b-form-input
                        id="shopPhone"
                        v-model="shopModel.email"
                        disabled
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('ShopInformation.ShopAddress')"
                    label-for="shopAddress"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Shop Address"
                      rules="required"
                    >
                      <b-form-input
                        id="shopPhone"
                        v-model="shopModel.address[0].addressLine1"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('ShopInformation.Province')"
                    label-for="province"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Province"
                      rules="required"
                    >
                      <!-- <b-form-input id="province" v-model="shopModel.address[0].province" /> -->
                      <v-select
                        v-model="provinceSelect"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="provinceOptions"
                        :clearable="false"
                        :state="errors.length > 0 ? false : null"
                        label="label"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('ShopInformation.Amphur')"
                    label-for="amphur"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Amphur"
                      rules="required"
                    >
                      <!-- <b-form-input id="amphur" v-model="shopModel.address[0].amphur" /> -->
                      <v-select
                        v-model="districtSelect"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="districtOptions"
                        :clearable="false"
                        :state="errors.length > 0 ? false : null"
                        label="label"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('ShopInformation.Tumbon')"
                    label-for="tumbon"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Tumbon"
                      rules="required"
                    >
                      <!-- <b-form-input id="tumbon" v-model="shopModel.address[0].tumbon" /> -->
                      <v-select
                        v-model="subDistrictSelect"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="subDistrictOptions"
                        :clearable="false"
                        :state="errors.length > 0 ? false : null"
                        label="label"
                      />

                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('ShopInformation.ZipCode')"
                    label-for="zipCode"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="ZipCode"
                      rules="required"
                    >
                      <b-form-input
                        id="zipCode"
                        v-model="shopModel.address[0].zipCode"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="''"
                    label-for="lat"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="lat"
                      rules="required"
                    >
                      <b-form-input
                        id="lat"
                        v-model="shopModel.address[0].latitude"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="''"
                    label-for="lng"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="lng"
                      rules="required"
                    >
                      <b-form-input
                        id="lng"
                        v-model="shopModel.address[0].longitude"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <div>
                <GmapMap
                  v-if="!shopMap"
                  ref="mapRef"
                  :center="center"
                  :zoom="18"
                  map-style-id="roadmap"
                  :options="mapOptions"
                  style="width: 100%; height: 50vmin"
                  @click="handleMapClick"
                >
                  <GmapMarker
                    :position="marker.position"
                    :clickable="true"
                    :draggable="true"
                    :center="center"
                    @drag="handleMarkerDrag"
                    @click="panToMarker"
                  />
                </GmapMap>
                <b-button
                  variant="success"
                  style="margin-top: 0.5rem; margin-bottom: 0.5rem; width: 100%"
                  @click="geolocate(null, null)"
                >
                  ตำแหน่งปัจจุบัน
                </b-button>
                <!-- <p>Selected Position: {{ marker.position }}</p> -->
              </div>

              <!-- <h5 class="my-2">
                เพิ่ม VDO
              </h5>

              <div>
                <el-upload
                  ref="upload"
                  action="#"
                  list-type="picture-card"
                  :auto-upload="false"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :on-change="handleChangeBanner"
                  :file-list="fileList"
                  accept="image/*"
                >
                  <i class="el-icon-plus" />
                </el-upload>

                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt="" />
                </el-dialog>

                <p class="mt-1 mb-2" style="font-size: 12px;">
                  1. ขนาด : ไม่เกิน 30 Mb, 1280x1280px <br />
                  2. ระยะเวลา : 10-60 วินาที <br />
                  3. นามสกุลไฟล์ : MP4 <br />
                  4. หมายเหตุ :
                  คุณสามารถเผยแพร่สินคำชิ้นนี้ได้ตั้งแต่ระหว่างที่วิดีโอกำลังอัปโหลด
                  โดยวิดีโอจะแสดงให้เห็นหลังการอัปโหลดเสร็จสิ้น
                </p>
              </div> -->

              <!-- <b-row class="mb-3">
                <b-col
                  cols="12"
                  class="d-flex"
                  style="justify-content: space-between"
                >
                  <h3>
                    {{ $t("ShopInformation.ProductList") }} -->
              <!-- รายการสินค้า -->
              <!-- </h3>
                  <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    variant="primary"
                    class="mb-75"
                    v-b-modal.modal-product-select
                  > -->
              <!-- {{ $t("ShopInformation.SelectProduct") }} -->
              <!-- เลือกสินค้า -->
              <!-- </b-button>
                </b-col>
                <b-col>
                  <draggable
                    v-model="list"
                    class="list-group list-group-flush cursor-move"
                    tag="ul"
                  >
                    <transition-group type="transition" name="flip-list">
                      <b-list-group-item
                        v-for="listItem in list"
                        :key="listItem.name"
                        tag="li"
                      >
                        <div class="d-flex">
                          <b-avatar :text="listItem.name.slice(0, 2)" />
                          <div class="ml-25" style="overflow: hidden">
                            <b-card-text class="font-weight-bold mb-0">
                              {{ listItem.name }}
                            </b-card-text> -->
              <!-- <small>{{ listItem.email }}</small> -->
              <!-- </div>
                        </div>
                      </b-list-group-item>
                    </transition-group>
                  </draggable></b-col
                >
              </b-row> -->
              <div class="d-flex align-items-center justify-content-center">
                <b-button
                  type="submit"
                  variant="primary"
                  style="width: 15rem"
                  @click.prevent="validationForm"
                >
                  <!-- <b-spinner
                v-if="isShowLoading"
                small
                class="mr-1"
              /> -->
                  {{ $t("ShopInformation.Save") }}
                  <!-- บันทึก -->
                </b-button>
              </div>
            </b-form>
          </validation-observer>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      id="modal-product-select"
      ref="modal-user"
      centered
      :title="$t('ShopInformation.SelectProduct')"
      size="lg"
      :ok-title="$t('ShopInformation.Confirm')"
      cancel-variant="outline-secondary"
      :cancel-title="$t('ShopInformation.Cancel')"
      @ok="confirmModal"
    >
      <b-row style="justify-content: center; display: flex; height: 30rem">
        <b-col cols="8">
          <b-form-group
            :label="$t('ShopInformation.SelectProduct')"
            label-cols="12"
          >
            <v-select
              v-model="selected"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              multiple
              label="name"
              :options="optionsProducts"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BTab,
  BTabs,
  BCard,
  BLink,
  BButton,
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BForm,
  BTable,
  BCardHeader,
  BCardTitle,
  BModal,
  BCardText,
  BCardFooter,
  BFormCheckbox,
  BFormDatepicker,
  BFormRadioGroup,
  BFormTextarea,
  BBreadcrumb,
  BBreadcrumbItem,
  BListGroup,
  BListGroupItem,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
import { ref, onUnmounted } from '@vue/composition-api'
import { stringToNumber } from '@/common'
import { getUserData } from '@/auth/utils'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// eslint-disable-next-line import/no-cycle
import router from '@/router'
import store from '@/store'
import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import productStoreModule from './productStoreModule'
import shopStoreModule from './shopStoreModule'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BModal,
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BForm,
    vSelect,
    Cleave,
    BFormTextarea,
    BBreadcrumb,
    BBreadcrumbItem,
    // BTable,
    // BCardHeader,
    // BCardTitle,
    BCardText,
    BCardFooter,
    BFormCheckbox,
    BFormDatepicker,
    // BFormRadioGroup,
    // BLink,
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
    BListGroup,
    BListGroupItem,
    draggable,

    Prism,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      // validation rules
      required,
      shopMap: false,
      dir: 'ltr',
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
        },
      },
      dialogImageUrl: '',
      dialogVisible: false,
      optionsTest: [{ value: 1, text: 'test' }],
      isShowProduct: false,
      list: [],
      option: [
        {
          name: 'Paz Joya',
          email: 'girliness@spotlike.co.uk',
        },
        {
          name: 'Sunshine Cose',
          email: 'executrixship@equisized.edu',
        },
        {
          name: 'Alba Dobbin',
          email: 'bidding@demibob.or',
        },
        {
          name: 'Marlin Hinchee',
          email: 'preholding@scuffly.co.uk',
        },
      ],
      selected: [],
      marker: { position: { lat: 10, lng: 10 } },
      center: { lat: 10, lng: 10 },
      mapOptions: {
        disableDefaultUI: true,
      },
      provinceSelect: {},
      districtSelect: {},
      subDistrictSelect: {},
    }
  },
  setup() {
    const userData = getUserData()
    // Register module
    if (!store.hasModule('shop')) store.registerModule('shop', shopStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule('shop')) store.unregisterModule('shop')
    })

    const shippings = ref([])

    const fileList = ref([])
    const fileListBanner = ref([])

    // const productModel = ref(null)
    const productModel = ref({
      productCode: '',
      productId: '00000000-0000-0000-0000-000000000000',
      name: '',
      description: '',
      price: 0,
      stockQuantity: 0,
      productBarcode: '',
      expiryDate: null,
      weight: 0,
      width: 0,
      length: 0,
      height: 0,
      mediaIds: [],
      mediaId: '00000000-0000-0000-0000-000000000000',
      shopImages: [],
      thumbnailUrl: '',
    })

    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null)
    const previewEl = ref(null)
    const shopModel = ref(null)
    const shopName = ref(null)
    const optionsProducts = ref([])
    store
      .dispatch('shop/fetchProducts', { id: userData.shopId })
      .then(response => {
        optionsProducts.value = response.data.data.list
      })
      .catch(error => {})
    store
      .dispatch('shop/getShop', { id: userData.shopId })
      .then(response => {
        console.log('response', response)
        shopModel.value = {
          shopName: response.data.shopName,
          contactId: response.data.contactId,
          fullName: response.data.fullName,
          contactCitizen: response.data.contactCitizen,
          description: response.data.description,
          // eslint-disable-next-line global-require
          avatar: require('@/assets/images/slider/07.jpg'),
          userName: response.data.userName,
          password: response.data.password,
          firstName: response.data.firstName,
          lastName: response.data.lastName,
          phone: response.data.phone,
          email: response.data.email,
          birthDate: response.data.birthDate,
          sex: '',
          address: response.data.address,
          idCardNumber: '',
          titleName: response.data.title,
          gender: '',
          nickName: '',
          description: response.data.description,
          mediaIds: [],
          thumbnailUrl: response.data.thumbnailUrl,
        }

        response.data.shopImages.forEach(file => {
          if (file.displayOrder == 0) {
            fileList.value.push({
              name: file.mediaId,
              url: file.mediaUrl,
              raw: null,
              status: 'success',
              // percentage: 0,
              // size: 0,
              // uid: file.id,
              // url: `data:${file.contentType};base64,${file.fileData}`,
            })
          }
        })
        if (response.data.thumbnailUrl) {
          fileListBanner.value.push({
            name: '',
            url: response.data.thumbnailUrl,
            raw: null,
            status: 'success',
            // percentage: 0,
            // size: 0,
            // uid: file.id,
            // url: `data:${file.contentType};base64,${file.fileData}`,
          })
        }

        shopName.value = response.data.shopName
      })
      .catch(error => {})

    const { inputImageRenderer } = useInputImageRenderer(
      refInputEl,
      base64 => {
        // eslint-disable-next-line no-param-reassign
        shopModel.value.avatar = base64
      },
    )

    const provinceOptions = ref([
      {
        label: 'กรุณาเลือกจังหวัด',
        value: null,
      },
    ])

    store
      .dispatch('shop/postProvince')
      .then(response => {
        if (response !== null) {
          response.data.data.forEach(data => {
            provinceOptions.value.push({
              value: data.province_Code,
              label: data.province_Name_TH,
            })
          })
        }
      })
      .catch(error => {
        console.log(error)
      })
    const districtOptions = ref([
      {
        label: 'กรุณาเลือกอำเภอ',
        value: null,
      },
    ])

    const subDistrictOptions = ref([
      {
        label: 'กรุณาเลือกตำบล',
        value: null,
      },
    ])

    return {
      productModel,
      shippings,
      fileList,

      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
      inputImageRenderer,
      fileListBanner,
      shopModel,
      shopName,
      optionsProducts,
      provinceOptions,
      districtOptions,
      subDistrictOptions,
    }
  },

  computed: {
    maxLength13() {
      return this.shopModel.contactCitizen == null ? true : this.shopModel.contactCitizen.length <= 13
    },
  },

  watch: {
    provinceSelect() {
      this.getDistict(this.provinceSelect.value, null)
    },
    districtSelect() {
      this.postSubDistrict(this.provinceSelect.value, this.districtSelect.value, null)
    },
    subDistrictSelect() {
      console.log(this.subDistrictSelect)
      this.postalCode = this.subDistrictSelect.postalCode
      this.shopModel.address[0].zipCode = this.postalCode
    },
  },

  mounted() {
    this.getShop()
  },

  methods: {
    // detects location from browser
    geolocate(lat, lng) {
      console.log('panToMarker', lat, lng)
      navigator.geolocation.getCurrentPosition(position => {
        console.log(parseFloat(lat), parseFloat(lng))
        console.log(position.coords.latitude, position.coords.longitude)

        this.marker.position = {
          lat: parseFloat(lat) || position.coords.latitude,
          lng: parseFloat(lng) || position.coords.longitude,
        }
        this.shopModel.address[0].latitude = lat || this.marker.position.lat
        this.shopModel.address[0].longitude = lng || this.marker.position.lng

        this.center = {
          lat: parseFloat(lat) || position.coords.latitude,
          lng: parseFloat(lng) || position.coords.longitude,
        }
        this.panToMarker()
      })
    },
    // sets the position of marker when dragged
    handleMarkerDrag(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() }
      this.shopModel.address[0].latitude = this.marker.position.lat
      this.shopModel.address[0].longitude = this.marker.position.lng
    },
    // Moves the map view port to marker
    panToMarker() {
      console.log('panToMarker', this.marker.position)
      this.$refs.mapRef.panTo(this.marker.position)
      this.$refs.mapRef.setZoom(10)
      this.shopMap = true
    },
    // Moves the marker to click position on the map
    handleMapClick(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() }
      this.shopModel.address[0].latitude = this.marker.position.lat
      this.shopModel.address[0].longitude = this.marker.position.lng
    },
    showToast(variant, icon, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Notification',
          icon,
          text,
          variant,
        },
      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove(file) {},
    handleChange(file, fileList) {
      const formData = new FormData() // Create FormData for upload file
      console.log('this.fileListBanner', this.fileListBanner)
      // this.fileListBanner = [];

      this.fileListBanner = [
        {
          name: '',
          url: file.url,
          raw: null,
          status: 'success',
          // percentage: 0,
          // size: 0,
          // uid: file.id,
          // url: `data:${file.contentType};base64,${file.fileData}`,
        },
      ]
      formData.append(file.uid, file.raw, file.name) // Add file for upload

      store
        .dispatch('shop/uploadFileMultiple', formData)
        .then(res => {
          if (res.status === 200) {
            this.shopModel.mediaId = res.data.data[0].id
          }
        })
        .catch(error => {
          this.showToast('danger', 'XCircleIcon', error.message)
        })
    },
    handleChangeBanner(file, fileList) {
      const formData = new FormData() // Create FormData for upload file

      formData.append(file.uid, file.raw, file.name) // Add file for upload

      store
        .dispatch('shop/uploadFileMultiple', formData)
        .then(res => {
          if (res.status === 200) {
            this.shopModel.mediaIds.push(res.data.data[0].id)
          }
        })
        .catch(error => {
          this.showToast('danger', 'XCircleIcon', error)
        })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        console.log('this.provinceSelect', this.provinceSelect)
        console.log('this.districtSelect', this.districtSelect)
        console.log('this.subDistrictSelect', this.subDistrictSelect)
        console.log('this.shopModel', this.shopModel)

        if (this.provinceSelect.value == null) {
          this.showToast('danger', 'XCircleIcon', 'กรุณากรอก จังหวัด')
        } else if (this.districtSelect.value == null) {
          this.showToast('danger', 'XCircleIcon', 'กรุณากรอก อำเภอ/เขต')
        } else if (this.subDistrictSelect.value == null) {
          this.showToast('danger', 'XCircleIcon', 'กรุณากรอก ตำบล/แขวง')
        } else if (success) {
          // this.disabledButton = true
          // this.isShowLoading = true
          console.log('this.getUserData')
          const userData = getUserData()
          console.log('this.userData', userData)

          /*
          const saveModel = {
            shopId: userData.shopId,
            shopName: this.shopModel.shopName,
            mediaId: this.shopModel.mediaId,

            status: true,
            description: this.shopModel.description,

            mediaIds: this.shopModel.mediaIds,
            shopImages: this.shopModel.shopImages,
          }
          */

          const saveModel = {
            shopId: userData.shopId,
            shopName: this.shopModel.shopName,
            mediaId: this.shopModel.mediaId,
            fullName: this.shopModel.fullName,
            contactCitizen: this.shopModel.contactCitizen,
            description: this.shopModel.description,
            phone: this.shopModel.phone,
            email: this.shopModel.email,
            address: [
              {
                addressId: this.shopModel.address[0].addressId,
                userAddressId: this.shopModel.address[0].userAddressId,
                contactName: this.shopModel.fullName,
                phone: this.shopModel.phone,
                addressLine1: this.shopModel.address[0].addressLine1,
                isDefault: true,
                tumbon: this.subDistrictSelect.label,
                amphur: this.districtSelect.label,
                province: this.provinceSelect.label,
                zipCode: this.shopModel.address[0].zipCode,
                email: this.shopModel.email,
                latitude: this.shopModel.address[0].latitude.toString(), // this.marker.position.lat.toString(),
                longitude: this.shopModel.address[0].longitude.toString(), // this.marker.position.lng.toString(),
              },
            ],
          }

          console.log('saveModel', saveModel)
          console.log('saveModel', JSON.stringify(saveModel))

          store
            .dispatch('shop/editShop', saveModel)
            .then(response0 => {
              if (response0.status === 200) {
                this.showToast('success', 'XCircleIcon', 'บันทึกข้อมูลสำเร็จ')

                store
                  .dispatch('shop/getShop', { id: userData.shopId })
                  .then(response => {
                    this.shopModel = {
                      shopName: response.data.shopName,
                      contactId: response.data.contactId,
                      // eslint-disable-next-line global-require
                      avatar: require('@/assets/images/slider/07.jpg'),
                      userName: response.data.userName,
                      password: response.data.password,
                      fullName: response.data.fullName,
                      contactCitizen: response.data.contactCitizen,
                      firstName: response.data.firstName,
                      lastName: response.data.lastName,
                      phone: response.data.phone,
                      email: response.data.email,
                      birthDate: response.data.birthDate,
                      sex: '',
                      idCardNumber: '',
                      titleName: response.data.title,
                      gender: '',
                      nickName: '',
                      description: response.data.description,
                      thumbnailUrl: response.data.thumbnailUrl,
                      shopImages: response.data.shopImages,
                      address: response.data.address,
                    }
                    this.fileListBanner = [
                      {
                        name: '',
                        url: response.data.thumbnailUrl,
                        raw: null,
                        status: 'success',
                        // percentage: 0,
                        // size: 0,
                        // uid: file.id,
                        // url: `data:${file.contentType};base64,${file.fileData}`,
                      },
                    ]
                    this.shopName = response.data.shopName
                  })
                  .catch(error => {})
              }
            })
            .catch(error => {
              this.showToast('danger', 'XCircleIcon', error)
            })
        }
      })
    },
    confirmModal() {
      this.list = this.selected
    },

    getDistict(province, value) {
      console.log('getDistict', province)
      console.log('value', value)
      store
        .dispatch('shop/postDistrict', province)
        .then(response => {
          console.log('response', response)
          if (response !== null) {
            this.districtOptions = [
              {
                label: 'กรุณาเลือกอำเภอ',
                value: null,
              },
            ]

            this.postalCode = ''
            this.districtSelect = {}
            this.subDistrictSelect = {}
            response.data.data.forEach(data => {
              this.districtOptions.push({
                value: data.district_Code,
                label: data.district_Name_TH,
              })
            })

            this.districtSelect = this.districtOptions[
              this.districtOptions.findIndex(
                x => x.label === value,
              )
            ]
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    postSubDistrict(province, district, value) {
      console.log('postSubDistrict', province)
      console.log('district', district)
      console.log('value', value)
      const payload = {
        province,
        district,
      }

      store
        .dispatch('shop/postSubDistrict', payload)
        .then(response => {
          console.log('response', response)
          if (response !== null) {
            this.subDistrictOptions = [
              {
                label: 'กรุณาเลือกตำบล',
                value: null,
              },
            ]
            this.subDistrictSelect = {}
            this.postalCode = ''
            response.data.data.forEach(data => {
              this.subDistrictOptions.push({
                value: data.subdistrict_Code,
                label: data.subdistrict_Name_TH,
                postalCode: data.postal_Code,
              })
            })

            const subDistrictOptions = this.subDistrictOptions[
              this.subDistrictOptions.findIndex(
                x => x.label === value,
              )
            ]
            console.log('subDistrictOptions', subDistrictOptions)

            this.subDistrictSelect = subDistrictOptions
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    getShop() {
      const userData = getUserData()
      store
        .dispatch('shop/getShop', { id: userData.shopId })
        .then(response => {
          console.log('response', response)

          this.shopModel = {
            shopName: response.data.shopName,
            contactId: response.data.contactId,
            // eslint-disable-next-line global-require
            avatar: require('@/assets/images/slider/07.jpg'),
            userName: response.data.userName,
            password: response.data.password,
            fullName: response.data.fullName,
            contactCitizen: response.data.contactCitizen || '',
            firstName: response.data.firstName,
            lastName: response.data.lastName,
            phone: response.data.phone,
            email: response.data.email,
            birthDate: response.data.birthDate,
            sex: '',
            idCardNumber: '',
            titleName: response.data.title,
            gender: '',
            nickName: '',
            description: response.data.description,
            thumbnailUrl: response.data.thumbnailUrl,
            shopImages: response.data.shopImages,
            address: response.data.address,
          }
          this.fileListBanner = [
            {
              name: '',
              url: response.data.thumbnailUrl,
              raw: null,
              status: 'success',
              // percentage: 0,
              // size: 0,
              // uid: file.id,
              // url: `data:${file.contentType};base64,${file.fileData}`,
            },
          ]
          this.shopName = response.data.shopName

          this.shopMap = false

          this.geolocate(this.shopModel.address[0].latitude, this.shopModel.address[0].longitude)

          console.log('this.shopModel.address[0]', this.shopModel.address[0])
          console.log('province', this.shopModel.address[0].province)
          console.log('amphur', this.shopModel.address[0].amphur)
          console.log('tumbon', this.shopModel.address[0].tumbon)

          console.log('provinceOptions', this.provinceOptions)

          console.log('provinceSelect', this.provinceSelect)
          console.log('provinceSelect value', this.provinceSelect.value)

          /*
          this.provinceSelect = {
            label: this.shopModel.address[0].province,
            value: this.shopModel.address[0].province,
          }
          */

          setTimeout(() => {
            this.provinceSelect = this.provinceOptions[
              this.provinceOptions.findIndex(
                x => x.label === this.shopModel.address[0].province,
              )
            ]
          }, 2222)

          setTimeout(() => {
            const provincevalue = this.provinceSelect.value || ''
            this.getDistict(
              provincevalue,
              this.shopModel.address[0].amphur,
            )
          }, 3333)

          // console.log('provinceSelect', this.provinceSelect)

          setTimeout(() => {
            // console.log('contactCitizen', response.data.contactCitizen)
            // this.shopModel.contactCitizen = response.data.contactCitizen || ''

            const provincevalue = this.provinceSelect.value || ''
            const districtValue = this.districtSelect.value || ''
            this.postSubDistrict(
              provincevalue,
              districtValue,
              this.shopModel.address[0].tumbon,
            )
          }, 4444)
          console.log('districtSelect', this.districtSelect)

          // console.log('subDistrictSelect', this.subDistrictSelect)
        })
        .catch(error => {})
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
